(() => {
  const OVERLAY_CLASSES = ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop'];

  function isOverlayOpen() {
    const body = document.body;
    if (!body || !body.classList) return false;
    return OVERLAY_CLASSES.some((cls) => body.classList.contains(cls));
  }

  function matchesInboxIframe(iframe) {
    if (!(iframe instanceof HTMLIFrameElement)) return false;
    const src = String(iframe.getAttribute('src') || '');
    const title = String(iframe.getAttribute('title') || '');
    const id = String(iframe.id || '');
    const name = String(iframe.name || '');
    const cls = String(iframe.className || '');
    const hay = `${src} ${title} ${id} ${name} ${cls}`.toLowerCase();

    if (hay.includes('inbox')) return true;
    if (hay.includes('shopify') && hay.includes('chat')) return true;
    return false;
  }

  function unique(elements) {
    const set = new Set();
    elements.forEach((el) => {
      if (el) set.add(el);
    });
    return Array.from(set);
  }

  function findTargets() {
    const targets = [];

    document.querySelectorAll('.chat-app').forEach((el) => targets.push(el));

    document.querySelectorAll('button[data-spec="toggle-button"]').forEach((btn) => {
      const host = btn.closest?.('.chat-app') || btn;
      targets.push(host);
    });

    document.querySelectorAll('iframe').forEach((iframe) => {
      if (matchesInboxIframe(iframe)) targets.push(iframe);
    });

    return unique(targets);
  }

  function setZIndex(el) {
    try {
      el?.style?.setProperty?.('z-index', '30', 'important');
    } catch {
      // ignore
    }
  }

  function setHidden(el, hidden) {
    try {
      if (hidden) el?.style?.setProperty?.('display', 'none', 'important');
      else el?.style?.removeProperty?.('display');
    } catch {
      // ignore
    }
  }

  function apply() {
    const hidden = isOverlayOpen();
    findTargets().forEach((el) => {
      setZIndex(el);
      setHidden(el, hidden);
    });
  }

  let scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleApply, { once: true });
  } else {
    scheduleApply();
  }

  // Watch body class changes (drawers/menus toggle overflow classes).
  const body = document.body;
  if (body && typeof MutationObserver !== 'undefined') {
    new MutationObserver(scheduleApply).observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  // Watch for the Inbox widget mounting later.
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(scheduleApply).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

